<style scoped lang="scss">
    .info-wrapper {
        p {
            margin: 0;
        }
    }
    .select-wrapper {
        label {
            padding-left: 10px;
        }
        input {
            margin-left: 20px;
        }
    }
</style>

<template>
    <div class="uk-width-1-1">
        <div class="uk-grid">
            <div class="uk-width-1-1 info-wrapper">
                <p><b>Household Member's Name:</b> {{ label }}</p>
                <p><b>Property Address:</b> {{ propertyAddress }}</p>
            </div>
            <div class="uk-width-1-1 uk-margin-top">
                <p><b>Within the last {{ programSettings['required-days-of-income-proof'] }} days, did you receive income from any of the following sources?</b></p>
                <table class="uk-table uk-hidden-small uk-table-striped">
                    <thead>
                    <tr>
                        <th>Income Type</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item, idx) in incomes">
                        <td width="70%">{{ item.label }}</td>
                        <td>
                            <div class="uk-margin-top select-wrapper">
                                <input type="radio" :id="`yes_${idx}_${member.id}`" :name="`action_select_${idx}_${member.id}`"  :value="true" v-model="item.val" @change="onChangeRadio(idx)"><label :for="`yes_${idx}_${member.id}`">Yes</label>
                                <input type="radio" :id="`no_${idx}_${member.id}`" :name="`action_select_${idx}_${member.id}`" :value="false" v-model="item.val" @change="onChangeRadio(idx)"><label :for="`no_${idx}_${member.id}`">No</label>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <div class="uk-width-1-1 uk-margin-large-top">
                <p>Under penalty of perjury, I certify that the information presented in this certification is true and accurate to the best of my knowledge.  I further understand that providing false representations constitutes an act of fraud. False, misleading, or incomplete information may result in the repayment of any funds received through the <b>{{ program['program_abbreviation'] }}</b> Program and other remedies available under applicable law.  I also give the <b>{{ program['agency_short_name'] }}</b> and its partners permission to obtain a copy of any tax returns from the Internal Revenue Service and to verify income and other information provided herein from other State agencies.</p>
                <div class="uk-width-1-1 uk-margin-top" v-if="programSettings['uses-esign-no-income']">
                    <validated-section field="signature_no_income" :errors="errors">
                        <signature-box @updated="onSignatureUpdated"
                                        :user-key="member.id"
                                        :is-signed="signatureData[member.id] && signatureData[member.id].signed_at !== null"
                                        :completed="signatureData[member.id] && signatureData[member.id].completed"
                                        :name="member.first_name + ' ' + member.last_name"
                                        :color="programSettings['primary-program-color']"
                        ></signature-box>
                    </validated-section>
                </div>
                <div v-else class="uk-width-1-1 uk-margin-top">
                    <DocRequest
                        :applicationId="application.id"
                        :member="member"
                        :incomes="incomes"
                        docType="no-income-hh"
                    ></DocRequest>
                </div>
            </div>
        </div>
        <modal-dialog
            title="Confirmation"
            ref="confirmModal"
            @close="onCloseModalConfirm"
            @confirm="onCompleteModalConfirm"
            confirmText="Okay"
            :showCancelButton="false"
        >
            Please return to the select an option to report the income you selected.  Complete the appropriate line item and include the support documentation with your application or complete the self-attestation of income if you do not have supporting documentation of income.
        </modal-dialog>
    </div>
</template>

<script>
    import { mapGetters, mapState } from 'vuex';
    import moment from 'moment';
    import ValidatedSection from "../../../components/Common/ValidatedSection";
    import PreviewDocumentModal from "../../../../dashboard/pages/Documents/PreviewDocumentModal";
    import SignatureBox from "../SignatureBox";
    import DocRequest from "./DocRequest";
    import ModalDialog from "../../../components/Common/ModalDialog";

    export default {
        name: "NoIncomeHHForm",
        props: {
            label: {
                type: String,
                default: ''
            },
            member: {
                type: Object,
                default: {}
            },
            members: {
                type: Array,
                default: []
            },
            url: {
                type: String,
                default: ''
            },
        },
        components: {
            ValidatedSection,
            PreviewDocumentModal,
            SignatureBox,
            ModalDialog,
            DocRequest
        },
        computed: {
            ...mapState('Application', {
                application: 'application',
                applicant: 'applicant',
            }),
            ...mapGetters('Application', [ 
                'program',
                'programSettings' 
            ]),
            propertyAddress() {
                let result = ''
                if (this.applicant.property_address)
                {
                    result = `${this.applicant.property_address.line_1} ${this.applicant.property_address.line_2}, ${this.applicant.property_address.city}, ${this.applicant.property_address.state}, ${this.applicant.property_address.zip}`
                }
                return result
            }
        },
        data() {
            return {
                errors: {},
                signatureData: {},
                selectedIndex: null,
                incomes: [
                    {
                        id: 'wages',
                        label: 'Wages, salaries, tips, bonus, commissions, etc.',
                        val: false
                    },
                    {
                        id: 'service_pay',
                        label: 'Severance pay',
                        val: false
                    },
                    {
                        id: 'worker-compensation',
                        label: 'Worker’s compensation',
                        val: false
                    },
                    {
                        id: 'interest',
                        label: 'Interest/dividends from assets, including bank accounts',
                        val: false
                    },
                    {
                        id: 'net-income',
                        label: 'Net income from the Operation of a Business or Profession',
                        val: false
                    },
                    {
                        id: 'self-employment',
                        label: 'Income from Self-employment, including direct sales consulting (i.e. Mary Kay, Tupperware), Uber/Lyft services, and online sales',
                        val: false
                    },
                    {
                        id: 'unemployment-benefit',
                        label: 'Unemployment benefits',
                        val: false
                    },
                    {
                        id: 'ssi',
                        label: 'Social Security or Supplemental Security Income (SSI)',
                        val: false
                    },
                    {
                        id: 'annuities',
                        label: 'Annuities, pensions, and retirement funds (i.e. IRA, 401K)',
                        val: false
                    },
                    {
                        id: 'insurance',
                        label: 'Insurance policies, disability, death benefits, or similar types of periodic receipts',
                        val: false
                    },
                    {
                        id: 'alimony',
                        label: 'Alimony or child support',
                        val: false
                    },
                    {
                        id: 'regular_contribution',
                        label: 'Regular contributions or gifts received from organizations or other persons not residing in the dwelling (including online donations such as GoFundMe or through a local bank)',
                        val: false
                    },
                    {
                        id: 'tanf',
                        label: 'Temporary Assistance for Needy Families (TANF)',
                        val: false
                    },
                    {
                        id: 'all_regular_pay',
                        label: 'All regular pay, special pay, and allowances of a member of the Armed Forces, except the special pay to a family member serving in the Armed Forces who is exposed to hostile fire (e.g., in the past, special pay included Operation Desert Storm)',
                        val: false
                    },
                    {
                        id: 'other_source',
                        label: 'Any other source (if yes, explain)',
                        val: false
                    },
                ],
            }
        },
        watch: {
            application(newValue) {
                if(newValue.household) {
                    this.initData();
                }
            }
        },
        mounted() {
        },
        methods: {
            initData() {
                this.signatureData = {}
                const signatureFiltered = this.member.signatures.find(item => item.key === `no-income-hh`)
                if(signatureFiltered) {
                    this.$set(this.signatureData, this.member.id, { signed_at: signatureFiltered.created_at, completed: true });
                }
            },

            onSignatureUpdated($event) {
                if(!this.signatureData[$event.key]) {
                    this.$set(this.signatureData, $event.key, {});
                }
                this.$set(this.signatureData, $event.key, { signed_at: $event.isSigned ? moment().format('YYYY-MM-DD HH:mm') : null});
            },

            onCloseModalConfirm() {
                
            },

            onCompleteModalConfirm() {
                setTimeout(() => {
                    this.$emit('confirmSelect', { 
                        member: this.member, 
                        incomeIndex: this.selectedIndex,
                    });
                }, 500)
            },

            onChangeRadio(index) {
                if (this.incomes[index].val === true) 
                {
                    this.selectedIndex = index
                    this.$refs.confirmModal.open();
                }
            },

            validate() {
                this.errors = {};
                let stepValid = true;
                if (this.programSettings['uses-esign-no-income'])
                {
                    if(!this.signatureData[this.member.id]) {
                        this.errors['signature_no_income'] = {
                            errors: [this.member.first_name + ' ' + this.member.last_name + ' must sign this form as their name appears above.'],
                        };
                    }else if(this.signatureData[this.member.id] && this.signatureData[this.member.id].signed_at == null) {
                        this.errors['signature_no_income'] = {
                            errors: [this.member.first_name + ' ' + this.member.last_name + ' must sign this form as their name appears above.'],
                        };
                    }
                }

                let errorCount = _.size(this.errors);

                if(errorCount > 0) stepValid = false;

                return stepValid
            },
        }
    }
</script>
